<template>

    <h1>Otelico</h1>

</template>

<script>
    export default {

    }
</script>